/**
 * Test IDs for QA automation.
 */
export const testIds = {
  stringCustomFieldInputValue: "string-custom-field-input-value",
} as const;
